/* Cooper & James: bundle order cards (pack size, colour, size breakdown, logo upload).
   Standard bundles: Colour x Bundle variants. Mixed bundles (Sole Trader): one variant + parts. */
(function () {
  function toInt(v) { return parseInt(v, 10) || 0; }

  /* A size picker: inputs inside wrap, must add up to qty(). allowed() returns sizes array or null (any). */
  function SizeGroup(wrap, countEl, hideEl) {
    this.wrap = wrap;
    this.countEl = countEl;
    this.hideEl = hideEl;
    this.inputs = Array.prototype.slice.call(wrap.querySelectorAll('[data-cj-bsize]'));
  }
  SizeGroup.prototype.apply = function (allowed, qty) {
    this.qty = qty;
    this.oneSize = !!(allowed && allowed.length === 0);
    if (this.hideEl) this.hideEl.hidden = this.oneSize;
    this.inputs.forEach(function (i) {
      var w = i.closest('[data-size]');
      var ok = !this.oneSize && (!allowed || allowed.indexOf(w.dataset.size) > -1);
      w.hidden = !ok;
      if (!ok) i.value = 0;
      i.max = qty || 10;
    }, this);
    var t = this.total();
    if (this.countEl) {
      this.countEl.textContent = t + ' of ' + qty + ' chosen';
      this.countEl.classList.toggle('is-done', t === qty);
      this.countEl.classList.toggle('is-over', t > qty);
    }
  };
  SizeGroup.prototype.total = function () {
    if (this.oneSize) return this.qty;
    return this.inputs.reduce(function (t, i) { return t + (i.closest('[data-size]').hidden ? 0 : toInt(i.value)); }, 0);
  };
  SizeGroup.prototype.summary = function () {
    if (this.oneSize) return 'One size x ' + this.qty;
    var out = [];
    this.inputs.forEach(function (i) {
      var n = toInt(i.value);
      if (n > 0 && !i.closest('[data-size]').hidden) out.push(i.dataset.cjBsize + ' x ' + n);
    });
    return out.join(', ');
  };

  function initBundle(card) {
    if (card.dataset.cjReady) return;
    card.dataset.cjReady = '1';
    var dataEl = card.querySelector('[data-cj-bdata]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sizesByColour = data.sizes || {};
    var variants = data.variants || [];
    var partsData = Array.isArray(data.parts) ? data.parts : null;
    var form = card.querySelector('[data-cj-bform]');
    var variantInput = form.querySelector('[data-cj-bvariant]');
    var sizesProp = form.querySelector('[data-cj-bsizes-prop]');
    var colourLabel = form.querySelector('[data-cj-bcolour-label]');
    var errorEl = form.querySelector('[data-cj-berror]');
    var logoInput = form.querySelector('[data-cj-blogo]');
    var logoName = form.querySelector('[data-cj-blogo-name]');
    var img = card.querySelector('.cj-bundle__mainimg');

    function setImg(src, alt) { if (img && src) { img.removeAttribute('srcset'); img.src = src; img.alt = alt || ''; } }
    function checked(scope, sel) { return scope.querySelector(sel + ':checked'); }

    /* ---------- mixed bundle (parts) ---------- */
    var parts = [];
    if (partsData) {
      Array.prototype.slice.call(form.querySelectorAll('[data-cj-part]')).forEach(function (el) {
        var idx = toInt(el.dataset.cjPart);
        var wrap = el.querySelector('[data-cj-psizes-wrap]');
        parts.push({
          el: el, def: partsData[idx], qty: toInt(el.dataset.qty),
          prop: el.querySelector('[data-cj-pprop]'),
          label: el.querySelector('[data-cj-pcolour-label]'),
          sizes: new SizeGroup(wrap, wrap.querySelector('[data-cj-bcount]'), wrap)
        });
      });
    }
    function partColour(p) { var c = checked(p.el, '[data-cj-pcolour]'); return c ? c.value : null; }

    /* ---------- standard bundle ---------- */
    var single = null;
    if (!partsData) {
      var sg = form.querySelector('[data-cj-bsizes-group]');
      if (sg) single = new SizeGroup(sg, sg.querySelector('[data-cj-bcount]'), sg);
    }
    function colour() { var c = checked(form, '[data-cj-bcolour]'); return c ? c.value : (variants[0] && variants[0].colour); }
    function packQty() { var p = checked(form, '[data-cj-bpack]'); return p ? toInt(p.dataset.qty) : 0; }

    function update(changed) {
      if (partsData) {
        parts.forEach(function (p) {
          var c = partColour(p);
          var cd = (p.def && p.def.colours && p.def.colours[c]) || {};
          if (p.label) p.label.textContent = c;
          p.sizes.apply(cd.sizes || null, p.qty);
          if (changed && p.el.contains(changed) && changed.matches('[data-cj-pcolour]')) setImg(cd.img, p.def.name + ' in ' + c);
        });
      } else {
        var c = colour();
        var pk = checked(form, '[data-cj-bpack]');
        var v = variants.filter(function (x) { return x.colour === c && x.pack === (pk ? pk.value : null); })[0];
        if (v) { variantInput.value = v.id; setImg(v.img, c); }
        if (colourLabel) colourLabel.textContent = c;
        if (single) single.apply(sizesByColour[c] || null, packQty());
      }
      if (errorEl && !errorEl.hidden) validate();
    }

    function validate() {
      var msg = '';
      if (partsData) {
        for (var k = 0; k < parts.length && !msg; k++) {
          var p = parts[k], t = p.sizes.total(), name = (p.def && p.def.name || 'items').toLowerCase();
          if (t < p.qty) msg = 'Please choose sizes for all ' + p.qty + ' ' + name + ' (' + t + ' chosen so far).';
          else if (t > p.qty) msg = 'You have chosen ' + t + ' sizes for the ' + name + ', but this bundle includes ' + p.qty + '.';
        }
      } else if (single) {
        var t2 = single.total(), q = packQty();
        if (t2 !== q) msg = t2 < q ? 'Please choose sizes for all ' + q + ' garments (' + t2 + ' chosen so far).' : 'You have chosen ' + t2 + ' sizes, but this bundle is ' + q + '. Please adjust the sizes or pick the larger bundle.';
      }
      if (!msg && (!logoInput.files || !logoInput.files.length)) msg = 'Please upload your logo so we can set it up for embroidery.';
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = !msg; }
      return !msg;
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cj-blogo]')) {
        var f = logoInput.files && logoInput.files[0];
        if (f && f.size > 20 * 1024 * 1024) {
          logoInput.value = '';
          if (logoName) logoName.textContent = 'Choose a file';
          if (errorEl) { errorEl.textContent = 'That file is over 20MB. Please upload a smaller version, or email it to us after ordering.'; errorEl.hidden = false; }
          return;
        }
        if (logoName) logoName.textContent = f ? f.name : 'Choose a file';
        card.querySelector('.cj-bform__upload').classList.toggle('has-file', !!f);
      }
      update(e.target);
    });
    form.addEventListener('input', function (e) { if (e.target.matches('[data-cj-bsize]')) update(e.target); });

    form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (partsData) {
        parts.forEach(function (p) { p.prop.value = partColour(p) + ': ' + p.sizes.summary(); });
      } else if (sizesProp && single) {
        sizesProp.value = single.summary();
      }
      var notes = form.querySelector('textarea[name="properties[Notes]"]');
      if (notes && !notes.value.trim()) notes.disabled = true;
      var btn = form.querySelector('[data-cj-bsubmit]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.lastChild.textContent = 'Uploading your logo…'; }
      // Native multipart submit so the logo file is attached to the order; Shopify then opens the basket.
    });

    window.addEventListener('pageshow', function () {
      var btn = form.querySelector('[data-cj-bsubmit]');
      if (btn && btn.disabled) { btn.disabled = false; btn.classList.remove('is-loading'); btn.lastChild.textContent = 'Add bundle to basket'; }
      var notes = form.querySelector('textarea[name="properties[Notes]"]');
      if (notes) notes.disabled = false;
    });

    update();
  }

  function initAll() { document.querySelectorAll('[data-cj-bundle]').forEach(initBundle); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
